<template>
  <div class="container-fluid h-100 p-0">
    <div class="row h-100 g-0">
      <div class="col-12 h-100">
        <div
          class="overflow-y-auto h-100 pt-4 px-3"
          style="height: calc(100vh - 60px)"
        >
          <!-- Selection Section Header -->
          <div class="d-flex justify-content-between align-items-center mb-3">
            <h2 class="h4 fw-semibold mb-0">
              {{ $t("project.previewAndReport.title") }}
            </h2>
            <div class="d-flex">
              <!--
              <button
                class="btn btn-outline-primary btn-sm me-2"
                style="height: 38px; padding-top: 8px; padding-bottom: 8px"
                @click="generateReport"
              >
                {{ $t("project.previewAndReport.generateDocx") }}
                <i class="bi bi-file-earmark-word ms-1"></i>
              </button>
              -->
              <button
                class="btn btn-primary btn-sm"
                style="height: 38px; padding-top: 8px; padding-bottom: 8px"
                @click="generatePDF"
              >
                {{ $t("project.previewAndReport.exportPdf") }}
                <i class="bi bi-file-earmark-pdf ms-1"></i>
              </button>
            </div>
          </div>

          <!-- Report Sections Selection -->
          <div
            class="card mb-5 mt-4"
            style="border: none; background-color: var(--color-light-light-gray)"
          >
            <div
              class="card-header bg-light pt-4"
              style="
                background-color: var(--color-light-light-gray) !important;
                border-bottom: none;
              "
            >
              <h3 class="h5 mb-1">
                {{ $t("project.previewAndReport.selectSections") }}
              </h3>
            </div>
            <div
              class="card-body pb-4"
              style="background-color: var(--color-light-light-gray)"
            >
              <!-- For product_supply, product_supply_commissioning, and full_service -->
              <template
                v-if="
                  [
                    'product_supply',
                    'product_supply_commissioning',
                    'full_service',
                  ].includes(serviceType)
                "
              >
                <div class="row">
                  <div class="col-12">
                    <div class="form-check mb-2">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        id="includeRenewInverter"
                        v-model="includeSections.renewInverter"
                        @change="updateRenewInverter"
                      />
                      <label
                        class="form-check-label"
                        for="includeRenewInverter"
                      >
                        {{
                          $t("project.previewAndReport.sections.renewInverter")
                        }}
                      </label>
                    </div>
                  </div>
                </div>
              </template>

              <!-- For complete_solution -->
              <template v-else>
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-check mb-2">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        id="includeRenewInverter"
                        v-model="includeSections.renewInverter"
                        @change="updateRenewInverter"
                      />
                      <label
                        class="form-check-label"
                        for="includeRenewInverter"
                      >
                        {{
                          $t("project.previewAndReport.sections.renewInverter")
                        }}
                      </label>
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="row">
                      <div class="col-md-6">
                        <div class="form-check mb-2">
                          <input
                            class="form-check-input"
                            type="checkbox"
                            id="includeCashFlow"
                            v-model="includeSections.cashFlow"
                          />
                          <label class="form-check-label" for="includeCashFlow">
                            {{ $t("project.previewAndReport.sections.cashFlow") }}
                          </label>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="mb-2">
                          <label class="form-label mb-1">
                            {{ $t("project.previewAndReport.sections.cashbackPercentage") }}
                          </label>
                          <select
                            class="form-select"
                            v-model="selectedCashbackPercentage"
                            @change="updateCashbackPercentage"
                          >
                            <option value="0">0%</option>
                            <option value="36">36%</option>
                            <option value="50">50%</option>
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Payment Type Selection -->
                <div class="row mt-3">
                  <div class="col-md-6">
                    <div class="form-check form-check-inline">
                      <input
                        class="form-check-input"
                        type="radio"
                        id="paymentTypeSingle"
                        value="one_time"
                        v-model="paymentType"
                      />
                      <label class="form-check-label" for="paymentTypeSingle">
                        {{ $t("project.previewAndReport.paymentType.single") }}
                      </label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input
                        class="form-check-input"
                        type="radio"
                        id="paymentTypeInstallment"
                        value="installment"
                        v-model="paymentType"
                      />
                      <label
                        class="form-check-label"
                        for="paymentTypeInstallment"
                      >
                        {{
                          $t("project.previewAndReport.paymentType.installment")
                        }}
                      </label>
                    </div>
                  </div>
                  <div class="col-md-6" v-if="paymentType === 'installment'">
                    <div class="row">
                      <div class="col-md-6">
                        <select
                          class="form-select"
                          v-model="selectedInstallmentRatio"
                          @change="updateInstallmentRatio"
                        >
                          <option
                            v-for="ratio in equipmentStore.installmentRatios"
                            :key="ratio.id"
                            :value="ratio.value"
                          >
                            {{ ratio.value }}%
                          </option>
                        </select>
                      </div>
                      <div class="col-md-6">
                        <select
                          class="form-select"
                          v-model="selectedYears"
                          @change="updateInstallmentDuration"
                        >
                          <option v-for="year in 10" :key="year" :value="year">
                            {{ year }}
                            {{
                              year === 1
                                ? $t("project.previewAndReport.years.singular")
                                : $t("project.previewAndReport.years.plural")
                            }}
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
              </template>

              <!-- Update Preview Button -->
              <div class="text-end mt-4">
                <button
                  class="btn btn-primary"
                  style="
                    height: 38px;
                    padding: 8px 20px;
                    background-color: var(--primary-color);
                    border-color: var(--primary-color);
                  "
                  @click="updatePreview"
                  :disabled="isUpdating"
                >
                  <span v-if="isUpdating">
                    {{ $t("project.previewAndReport.updatePreview") }}
                    <span
                      class="spinner-border spinner-border-sm ms-2"
                      role="status"
                      aria-hidden="true"
                    ></span>
                  </span>
                  <span v-else>
                    {{ $t("project.previewAndReport.updatePreview") }}
                    <i class="bi bi-arrow-repeat ms-1"></i>
                  </span>
                </button>
              </div>
            </div>
          </div>

          <!-- Preview Section Header -->
          <div class="mb-4">
            <h2 class="h4 fw-semibold">
              {{ $t("project.previewAndReport.preview") }}
            </h2>
          </div>

          <!-- Report Component -->
          <ReportComponent
            :project-data="projectData"
            :include-sections="includeSections"
            :consumption-data="consumptionData"
            :selected-panels="selectedPanels"
            :selected-inverters="selectedInverters"
            :selected-batteries="selectedBatteries"
            :selectedEVChargers="selectedEVChargers"
            :selected-meters="selectedMeters"
            :payment-type="paymentType"
            :get-panel-device-count="getPanelDeviceCount"
            :get-inverter-device-count="getInverterDeviceCount"
            :get-battery-device-count="getBatteryDeviceCount"
            :getEVChargerDeviceCount="getEVChargerDeviceCount"
            :get-meter-device-count="getMeterDeviceCount"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import {
  defineComponent,
  ref,
  computed,
  onMounted,
  watch,
  onBeforeUnmount,
} from "vue";
import { useMapStateStore } from "@/stores/mapState";
import { useEquipmentStore } from "@/stores/equipment";
import { useProjectStore } from "@/stores/project";
import { storeToRefs } from "pinia";
import ReportComponent from "@/components/report/ReportComponent.vue";
import type {
  Panel,
  Inverter,
  Project,
  ProjectDevice,
  Battery,
  EVCharger,
  Meter,
} from "@/types/projectTypes";
import { generateDOCXReport, generatePDFReport } from "@/utils/reportUtils";
import {
  totalPower,
  totalBattery,
  totalPrice,
  annualRevenue,
  coefficient,
  annualProduction,
  monthlyInstallment,
  cashFlowChartData,
  calculateCashbackAmount,
} from "@/utils/calculationUtils";
import { useI18n } from "vue-i18n";
import { PropType } from "vue";
import Chart from "chart.js/auto";

export default defineComponent({
  name: "ProjectPreviewAndReportComponent2",
  components: {
    ReportComponent,
  },
  props: {
    projectId: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const { t } = useI18n();
    const mapStateStore = useMapStateStore();
    const equipmentStore = useEquipmentStore();
    const projectStore = useProjectStore();
    const { project } = storeToRefs(projectStore);

    // Section selection controls
    const includeSections = ref({
      projectInfo: true,
      screenshot: true,
      evChargers: true,
      meters: true,
      consumption: true,
      cashFlow: true,
      installments: true,
      prices: true,
      renewInverter: false,
    });

    // Project data from store
    const projectData = ref<Project | null>(null);
    const consumptionData = ref({
      totalF1: 0,
      totalF2: 0,
      totalF3: 0,
      grandTotal: 0,
    });

    // Get selected equipment from store
    const selectedPanels = ref<Panel[]>([]);
    const selectedInverters = ref<Inverter[]>([]);
    const selectedBatteries = ref<Battery[]>([]);
    const selectedEVChargers = ref<EVCharger[]>([]);
    const selectedMeters = ref<Meter[]>([]);

    // Payment type selection
    const paymentType = ref("installment");
    const selectedInstallmentRatio = ref<number>(
      equipmentStore.installmentRatios[0]?.value || 0
    );
    const selectedYears = ref(10);
    const selectedCashbackPercentage = ref<number>(0);

    // Get service type from project store
    const serviceType = computed(
      () => project.value?.service_type || "product_supply"
    );

    // Add function to update installment duration
    const updateInstallmentDuration = async () => {
      if (project.value && project.value.financial_data) {
        projectStore.$patch((state) => {
          if (state.project && state.project.financial_data) {
            state.project.financial_data.installment_duration_months =
              selectedYears.value * 12;
          }
        });
        await updatePreview();
      }
    };

    // Update installment ratio in project store
    const updateInstallmentRatio = async () => {
      if (project.value && project.value.financial_data) {
        projectStore.$patch((state) => {
          if (state.project && state.project.financial_data) {
            state.project.financial_data.installment_ratio =
              selectedInstallmentRatio.value;
          }
        });
        await updatePreview();
      }
    };

    // Update renew inverter
    const updateRenewInverter = async () => {
      if (project.value && project.value.financial_data) {
        projectStore.$patch((state) => {
          if (state.project && state.project.financial_data) {
            state.project.financial_data.include_renew_inverter =
              includeSections.value.renewInverter;
          }
        });
        await updatePreview();
      }
    };

    // Update cashback percentage
    const updateCashbackPercentage = async () => {
      if (project.value && project.value.financial_data) {
        // Calculate cashback amount based on the new percentage
        const calculatedCashbackAmount = calculateCashbackAmount();
        
        projectStore.$patch((state) => {
          if (state.project && state.project.financial_data) {
            state.project.financial_data.cashback_percentage = selectedCashbackPercentage.value;
            state.project.financial_data.cashback_amount = calculatedCashbackAmount;
          }
        });
        await updatePreview();
      }
    };

    // Generate DOCX report
    const generateReport = async () => {
      try {
        if (!projectData.value) return;

        await generateDOCXReport(
          projectData.value,
          includeSections.value,
          selectedPanels.value,
          selectedInverters.value,
          mapStateStore.screenshot_info?.imageUrl || null,
          consumptionData.value
        );
      } catch (error) {
        console.error("Error generating document:", error);
        alert(t("project.previewAndReport.errors.docxGenerationFailed"));
      }
    };

    // Generate PDF report
    const generatePDF = async () => {
      try {
        if (!projectData.value) return;

        await generatePDFReport(
          projectData.value,
          includeSections.value,
          selectedPanels.value,
          selectedInverters.value,
          mapStateStore.screenshot_info?.imageUrl || null,
          consumptionData.value,
          selectedBatteries.value,
          selectedEVChargers.value
        );
      } catch (error) {
        console.error("Error generating PDF:", error);
        alert(t("project.previewAndReport.errors.pdfGenerationFailed"));
      }
    };

    // Update preview
    const isUpdating = ref(false);
    const updatePreview = async () => {
      try {
        if (!project.value) return;

        isUpdating.value = true;

        // Recalculate all project values
        const calculatedTotalPower: number = totalPower();
        const calculatedTotalBattery: number = totalBattery();
        const calculatedTotalPrice: number = roundFinancialValue(totalPrice());
        const calculatedPerformanceRatio = await coefficient();
        const calculatedAnnualProduction = await annualProduction();
        const calculatedAnnualRevenue: number = roundFinancialValue(
          await annualRevenue()
        );
        const calculatedMonthlyInstallment: number = roundFinancialValue(
          monthlyInstallment()
        );
        const calculatedCashbackAmount: number = roundFinancialValue(
          calculateCashbackAmount()
        );

        // Update project store with new calculations
        projectStore.$patch((state) => {
          if (state.project) {
            state.project.total_power = calculatedTotalPower;
            state.project.total_battery = calculatedTotalBattery;
            state.project.performance_ratio = calculatedPerformanceRatio;
            state.project.annual_production = calculatedAnnualProduction;

            if (!state.project.financial_data) {
              state.project.financial_data = {
                payment_type: "one_time",
                installment_ratio: selectedInstallmentRatio.value,
                installment_duration_months: 120,
                import_energy_price: 0,
                export_energy_price: 0,
                annual_revenue: 0,
                base_price: 0,
                discount_amount: 0,
                discount_percentage: 0,
                final_price: 0,
                installment_amount: 0,
                total_installment_amount: 0,
                payment_schedule: [],
                currency: "EUR",
                vat_percentage: 0,
                vat_amount: 0,
                cashback_amount: 0,
                cashback_percentage: 0,
                include_renew_inverter: false,
                created_at: new Date().toISOString(),
                updated_at: new Date().toISOString(),
              };
            }

            state.project.financial_data.final_price = calculatedTotalPrice;
            state.project.financial_data.annual_revenue =
              calculatedAnnualRevenue;
            state.project.financial_data.installment_amount =
              calculatedMonthlyInstallment;
            state.project.financial_data.cashback_amount = calculatedCashbackAmount;
            state.project.financial_data.payment_type = paymentType.value as
              | "installment"
              | "one_time";
          }
        });

        // Update project data reference
        projectData.value = project.value;

        // Update consumption data if available
        if (project.value.consumption_data) {
          consumptionData.value = {
            totalF1: project.value.consumption_data.f1_data.reduce(
              (a: number, b: number) => a + b,
              0
            ),
            totalF2: project.value.consumption_data.f2_data.reduce(
              (a: number, b: number) => a + b,
              0
            ),
            totalF3: project.value.consumption_data.f3_data.reduce(
              (a: number, b: number) => a + b,
              0
            ),
            grandTotal: project.value.consumption_data.grand_total,
          };
        }

        // Update cash flow chart
        await createCashFlowChart();
      } catch (error) {
        console.error("Failed to update preview:", error);
      } finally {
        isUpdating.value = false;
      }
    };

    // Helper function to round financial values
    const roundFinancialValue = (value: number | null | undefined): number => {
      if (value === null || value === undefined) {
        return 0;
      }
      const rounded = Math.round(value * 100) / 100;
      const strValue = rounded.toString().replace(".", "");
      if (strValue.length > 10) {
        return Number(rounded.toFixed(8 - strValue.length));
      }
      return rounded;
    };

    // Device count getters
    const getPanelDeviceCount = (panelId: number) => {
      return computed(() => {
        return (
          projectData.value?.devices
            .filter((d: ProjectDevice) => d.device_id === panelId && d.device_type === "Panel")
            .reduce((sum, d) => sum + d.pcs, 0) || 0
        );
      });
    };

    const getInverterDeviceCount = (inverterId: number) => {
      return computed(() => {
        return (
          projectData.value?.devices
            .filter((d: ProjectDevice) => d.device_id === inverterId && d.device_type === "Inverter")
            .reduce((sum, d) => sum + d.pcs, 0) || 0
        );
      });
    };

    const getBatteryDeviceCount = (batteryId: number) => {
      return computed(() => {
        return (
          projectData.value?.devices
            .filter((d: ProjectDevice) => d.device_id === batteryId && d.device_type === "Battery")
            .reduce((sum, d) => sum + d.pcs, 0) || 0
        );
      });
    };

    const getEVChargerDeviceCount = (chargerId: number) => {
      return computed(() => {
        return (
          projectData.value?.devices
            .filter((d: ProjectDevice) => d.device_id === chargerId && d.device_type === "EVCharger")
            .reduce((sum, d) => sum + d.pcs, 0) || 0
        );
      });
    };

    const getMeterDeviceCount = (meterId: number) => {
      return computed(() => {
        return (
          projectData.value?.devices
            .filter((d: ProjectDevice) => d.device_id === meterId && d.device_type === "Meter")
            .reduce((sum, d) => sum + d.pcs, 0) || 0
        );
      });
    };

    // Add cash flow chart functionality
    const cashFlowChart = ref<HTMLCanvasElement | null>(null);
    let cashFlowChartInstance: any = null;

    const createCashFlowChart = async () => {
      if (
        !cashFlowChart.value ||
        !projectData.value ||
        !projectData.value.financial_data
      )
        return;

      try {
        // Get canvas context
        const ctx = cashFlowChart.value.getContext("2d");
        if (!ctx) return;

        // Ensure the previous chart is destroyed properly
        if (cashFlowChartInstance) {
          cashFlowChartInstance.destroy();
          cashFlowChartInstance = null;
          // Add a small delay to ensure the chart is fully destroyed
          await new Promise((resolve) => setTimeout(resolve, 50));
        }

        // Get cash flow data from calculationUtils
        const cashFlowData = await cashFlowChartData();

        const style = getComputedStyle(cashFlowChart.value);
        const positiveColor =
          style.getPropertyValue("--color-graph-green").trim() || "#36f1b9";
        const negativeColor =
          style.getPropertyValue("--description-color").trim() || "#f87ce4";

        // Create color array (red for negative, green for positive)
        const backgroundColors = cashFlowData.map((value: number) =>
          value < 0 ? negativeColor : positiveColor
        );

        // Create chart
        cashFlowChartInstance = new Chart(ctx!, {
          type: "bar",
          data: {
            labels: Array.from({ length: 26 }, (_, i) => `Year ${i}`),
            datasets: [
              {
                label: t("project.previewAndReport.cashFlow.label"),
                data: cashFlowData,
                backgroundColor: backgroundColors,
                borderColor: backgroundColors.map((color: string) =>
                  color.replace("0.7", "1")
                ),
                borderWidth: 1,
              },
            ],
          },
          options: {
            responsive: true,
            maintainAspectRatio: false,
            scales: {
              y: {
                beginAtZero: false,
                title: {
                  display: true,
                  text: t("project.previewAndReport.cashFlow.yAxis"),
                },
              },
              x: {
                title: {
                  display: true,
                  text: t("project.previewAndReport.cashFlow.xAxis"),
                },
              },
            },
            plugins: {
              tooltip: {
                callbacks: {
                  label: function (context) {
                    let label = context.dataset.label || "";
                    if (label) {
                      label += ": ";
                    }
                    if (context.parsed.y !== null) {
                      label += new Intl.NumberFormat("en-EU", {
                        style: "currency",
                        currency: "EUR",
                      }).format(context.parsed.y);
                    }
                    return label;
                  },
                },
              },
            },
          },
        });
      } catch (error) {
        console.error("Error creating cash flow chart:", error);
      }
    };

    // Add cleanup in onBeforeUnmount
    onBeforeUnmount(() => {
      if (cashFlowChartInstance) {
        cashFlowChartInstance.destroy();
      }
    });

    // Add watcher for project data to update chart
    watch(
      () => [
        projectData.value?.financial_data?.final_price,
        projectData.value?.financial_data?.annual_revenue,
        projectData.value?.financial_data?.installment_duration_months,
        projectData.value?.financial_data?.installment_ratio,
        projectData.value?.financial_data?.include_renew_inverter,
      ],
      async () => {
        await createCashFlowChart();
      }
    );

    // Initialize data on mount
    onMounted(async () => {
      try {
        if (project.value) {
          projectData.value = project.value;

          // Calculate and update project values
          const calculatedTotalPower: number = totalPower();
          const calculatedTotalBattery: number = totalBattery();
          const calculatedTotalPrice: number = roundFinancialValue(
            totalPrice()
          );
          const calculatedPerformanceRatio = await coefficient();
          const calculatedAnnualProduction = await annualProduction();
          const calculatedAnnualRevenue: number = roundFinancialValue(
            await annualRevenue()
          );
          const calculatedMonthlyInstallment: number = roundFinancialValue(
            monthlyInstallment()
          );
          const calculatedCashbackAmount: number = roundFinancialValue(
            calculateCashbackAmount()
          );

          projectStore.$patch((state) => {
            if (state.project) {
              state.project.total_power = calculatedTotalPower;
              state.project.total_battery = calculatedTotalBattery;
              state.project.performance_ratio = calculatedPerformanceRatio;
              state.project.annual_production = calculatedAnnualProduction;

              if (!state.project.financial_data) {
                state.project.financial_data = {
                  payment_type: "one_time",
                  installment_ratio: selectedInstallmentRatio.value,
                  installment_duration_months: 120,
                  import_energy_price: 0,
                  export_energy_price: 0,
                  annual_revenue: 0,
                  base_price: 0,
                  discount_amount: 0,
                  discount_percentage: 0,
                  cashback_amount: 0,
                  cashback_percentage: 0,
                  final_price: 0,
                  installment_amount: 0,
                  total_installment_amount: 0,
                  payment_schedule: [],
                  currency: "EUR",
                  vat_percentage: 0,
                  vat_amount: 0,
                  include_renew_inverter: false,
                  created_at: new Date().toISOString(),
                  updated_at: new Date().toISOString(),
                };
              }

              state.project.financial_data.final_price = calculatedTotalPrice;
              state.project.financial_data.annual_revenue =
                calculatedAnnualRevenue;
              state.project.financial_data.installment_amount =
                calculatedMonthlyInstallment;
              state.project.financial_data.cashback_amount = calculatedCashbackAmount;
            }
          });

          // Get consumption data totals
          if (project.value.consumption_data) {
            consumptionData.value = {
              totalF1: project.value.consumption_data.f1_data.reduce(
                (a: number, b: number) => a + b,
                0
              ),
              totalF2: project.value.consumption_data.f2_data.reduce(
                (a: number, b: number) => a + b,
                0
              ),
              totalF3: project.value.consumption_data.f3_data.reduce(
                (a: number, b: number) => a + b,
                0
              ),
              grandTotal: project.value.consumption_data.grand_total,
            };
          }

          // Get selected equipment
          const projectPanels = project.value.devices
            .filter((device: ProjectDevice) => device.device_type === "Panel")
            .map((device: ProjectDevice) => {
              const fullPanel = equipmentStore.panels.find(
                (p: Panel) => p.id === device.device_id
              );
              return fullPanel;
            })
            .filter((panel): panel is Panel => panel !== undefined);

          const projectInverters = project.value.devices
            .filter(
              (device: ProjectDevice) => device.device_type === "Inverter"
            )
            .map((device: ProjectDevice) => {
              const fullInverter = equipmentStore.inverters.find(
                (i: Inverter) => i.id === device.device_id
              );
              return fullInverter;
            })
            .filter((inverter): inverter is Inverter => inverter !== undefined);

          const projectBatteries = project.value.devices
            .filter((device: ProjectDevice) => device.device_type === "Battery")
            .map((device: ProjectDevice) => {
              const fullBattery = equipmentStore.batteries.find(
                (b: Battery) => b.id === device.device_id
              );
              return fullBattery;
            })
            .filter((battery): battery is Battery => battery !== undefined);

          const projectEVChargers = project.value.devices
            .filter(
              (device: ProjectDevice) => device.device_type === "EVCharger"
            )
            .map((device: ProjectDevice) => {
              const fullEVCharger = equipmentStore.evChargers.find(
                (ev: EVCharger) => ev.id === device.device_id
              );
              return fullEVCharger;
            })
            .filter(
              (evCharger): evCharger is EVCharger => evCharger !== undefined
            );

          const projectMeters = project.value.devices
            .filter((device: ProjectDevice) => device.device_type === "Meter")
            .map((device: ProjectDevice) => {
              const fullMeter = equipmentStore.meters.find(
                (m: Meter) => m.id === device.device_id
              );
              return fullMeter;
            })
            .filter((meter): meter is Meter => meter !== undefined);

          if (projectPanels && projectPanels.length > 0) {
            selectedPanels.value = projectPanels;
          }

          if (projectInverters && projectInverters.length > 0) {
            selectedInverters.value = projectInverters;
          }

          if (projectBatteries && projectBatteries.length > 0) {
            selectedBatteries.value = projectBatteries;
          }

          if (projectEVChargers && projectEVChargers.length > 0) {
            selectedEVChargers.value = projectEVChargers;
          }

          if (projectMeters && projectMeters.length > 0) {
            selectedMeters.value = projectMeters;
          }

          // Set initial installment ratio
          if (project.value.financial_data?.installment_ratio) {
            selectedInstallmentRatio.value =
              project.value.financial_data.installment_ratio;
          } else {
            selectedInstallmentRatio.value =
              equipmentStore.installmentRatios[0]?.value || 0;
            updateInstallmentRatio();
          }

          // Set initial installment duration
          if (project.value.financial_data?.installment_duration_months) {
            selectedYears.value =
              project.value.financial_data.installment_duration_months / 12;
          } else {
            selectedYears.value = 10;
            updateInstallmentDuration();
          }

          // Set initial cashback percentage
          if (project.value.financial_data?.cashback_percentage !== undefined) {
            selectedCashbackPercentage.value = project.value.financial_data.cashback_percentage;
          } else {
            selectedCashbackPercentage.value = 0;
            updateCashbackPercentage();
          }

          // Set initial payment type from project data
          if (project.value.financial_data?.payment_type) {
            paymentType.value = project.value.financial_data.payment_type;
          }
        }
      } catch (error) {
        console.error("Failed to initialize project data:", error);
      }
    });

    // Set payment type to one_time for non-complete solutions
    watch(
      serviceType,
      (newType) => {
        if (
          [
            "product_supply",
            "product_supply_commissioning",
            "full_service",
          ].includes(newType)
        ) {
          paymentType.value = "one_time";
        }
      },
      { immediate: true }
    );

    // Watch for project data changes to initialize payment type
    watch(
      () => project.value?.financial_data?.payment_type,
      (newPaymentType) => {
        if (newPaymentType) {
          paymentType.value = newPaymentType;
        }
      },
      { immediate: true }
    );

    // Add watcher for payment type changes
    watch(paymentType, async (newType) => {
      if (project.value && project.value.financial_data) {
        projectStore.$patch((state) => {
          if (state.project && state.project.financial_data) {
            state.project.financial_data.payment_type = newType as
              | "one_time"
              | "installment";
          }
        });
        await updatePreview();
      }
    });

    return {
      includeSections,
      projectData,
      consumptionData,
      selectedPanels,
      selectedInverters,
      selectedBatteries,
      selectedEVChargers,
      paymentType,
      selectedInstallmentRatio,
      selectedYears,
      selectedCashbackPercentage,
      equipmentStore,
      generateReport,
      generatePDF,
      updatePreview,
      updateInstallmentRatio,
      updateInstallmentDuration,
      updateRenewInverter,
      updateCashbackPercentage,
      getPanelDeviceCount,
      getInverterDeviceCount,
      getBatteryDeviceCount,
      getEVChargerDeviceCount,
      getMeterDeviceCount,
      selectedMeters,
      isUpdating,
      serviceType,
      cashFlowChart,
    };
  },
});
</script>

<style scoped>
.card {
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  border-radius: 2px;
  border: 1px solid rgba(0, 0, 0, 0.125);
}

.form-check-input:checked {
  background-color: var(--primary-color);
  border-color: var(--primary-color);
  border-radius: 2px;
}

.form-check-input {
  border-radius: 2px;
}

.form-select {
  border-radius: 2px;
}

.form-control {
  border-radius: 2px;
}

.btn {
  border-radius: 2px;
}

.btn-primary {
  background-color: var(--primary-color) !important;
  border-color: var(--primary-color) !important;
  color: var(--color-white) !important;
}

.btn-primary:hover {
  background-color: var(--secondary-color) !important;
  border-color: var(--secondary-color) !important;
  color: var(--color-white) !important;
}

.btn-outline-primary {
  background-color: transparent !important;
  border-color: var(--primary-color) !important;
  color: var(--primary-color) !important;
}

.btn-outline-primary:hover {
  background-color: var(--primary-color) !important;
  border-color: var(--primary-color) !important;
  color: var(--color-white) !important;
}

.btn:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.alert {
  border-radius: 2px;
}
</style>
